// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blueScrollWindowPromptDisplayNoneAnimation {
    animation: fadeOutGlobal 1s forwards;
    z-index: -1;
}

.blueScrollWindowPromptDisplayNone {
    display: none;
    z-index: -1;
}

.blueScrollWindowPrompt {
    display: block;
}

.blueScrollWindowPromptbackground {
    min-width: 100%;
    min-height: 100%;
    background-color: black;
    opacity: 0.5;
    position: fixed;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 222;
    overflow: hidden;
}

.blueScrollWindowPromptContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--DarkBlue);
    padding: 1.5em;
    border-radius: 2em;
    -webkit-box-shadow: -2px -1px 15px 7px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: -3px -2px 30px 14px rgba(0, 0, 0, 0.425);
    box-shadow: -4px -3px 45px 21px rgba(0, 0, 0, 0.35);
    animation: fadeInGlobal 1s;
    z-index: 222;
}

.blueScrollWindowPromptTitle {
    font-size: 25px;
    text-align: center;
}

.blueScrollWindowPromptContent {
    overflow-x: auto;
    max-height: 20em;
    max-width: 40em;
    background-color: var(--GrayBlue);
    font-size: 12px;
    font-family: monospace;
    white-space: pre-wrap;

    padding: 1em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.blueScrollWindowPromptbuttons {
    display: inline-flex;
    justify-content: center;
    padding-top: 1em;

    min-width: 100%;
    gap: 2em;
}

@media only screen and (max-width: 768px) {
    .blueScrollWindowPromptContent {
        max-height: 38em;
        max-width: 80%;
        display: flex;
        justify-content: center;
    }

    .blueScrollWindowPromptContainer {
        width: 80%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/BlueScrollWindowPrompt/BlueScrollWindowPrompt.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,yDAAyD;IACzD,yDAAyD;IACzD,mDAAmD;IACnD,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,sBAAsB;IACtB,qBAAqB;;IAErB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;;IAEhB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".blueScrollWindowPromptDisplayNoneAnimation {\n    animation: fadeOutGlobal 1s forwards;\n    z-index: -1;\n}\n\n.blueScrollWindowPromptDisplayNone {\n    display: none;\n    z-index: -1;\n}\n\n.blueScrollWindowPrompt {\n    display: block;\n}\n\n.blueScrollWindowPromptbackground {\n    min-width: 100%;\n    min-height: 100%;\n    background-color: black;\n    opacity: 0.5;\n    position: fixed;\n    margin: 0;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 222;\n    overflow: hidden;\n}\n\n.blueScrollWindowPromptContainer {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--DarkBlue);\n    padding: 1.5em;\n    border-radius: 2em;\n    -webkit-box-shadow: -2px -1px 15px 7px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: -3px -2px 30px 14px rgba(0, 0, 0, 0.425);\n    box-shadow: -4px -3px 45px 21px rgba(0, 0, 0, 0.35);\n    animation: fadeInGlobal 1s;\n    z-index: 222;\n}\n\n.blueScrollWindowPromptTitle {\n    font-size: 25px;\n    text-align: center;\n}\n\n.blueScrollWindowPromptContent {\n    overflow-x: auto;\n    max-height: 20em;\n    max-width: 40em;\n    background-color: var(--GrayBlue);\n    font-size: 12px;\n    font-family: monospace;\n    white-space: pre-wrap;\n\n    padding: 1em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.blueScrollWindowPromptbuttons {\n    display: inline-flex;\n    justify-content: center;\n    padding-top: 1em;\n\n    min-width: 100%;\n    gap: 2em;\n}\n\n@media only screen and (max-width: 768px) {\n    .blueScrollWindowPromptContent {\n        max-height: 38em;\n        max-width: 80%;\n        display: flex;\n        justify-content: center;\n    }\n\n    .blueScrollWindowPromptContainer {\n        width: 80%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
